// extracted by mini-css-extract-plugin
module.exports = {"tSuspendButton":"index_tSuspendButton__2F16k","person":"index_person___3DnY","t-suspend-button-animate":"index_t-suspend-button-animate__1i8Tt"};